import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
	root: {
		flexGrow: 1,
	},
	title: {
		flexGrow: 1,
	},	
	contenedorPrincipal: {
		backgroundColor: '#D4D8E1',
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	contanedorAppBar: {
		margin: '0px 38px'
	},
	appBar: {
		backgroundColor: '#01579B',
	},
	success: {
		color: 'green',
		borderColor: 'green',
	},
	error: {
		color: 'red',
		borderColor: 'red',
	},
	buttonUpdate:{
		color: 'white',
	}
}))